module.exports = __webpack_public_path__ + "resources/169e42795f87d10c73d4d8bec3a41520.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/villaintransformed.png
// module id = 230
// module chunks = 0